import Cookies from 'js-cookie'
import Vue from 'vue'

const S = new Vue()

/**
 * 用于判断当前的运行环境，包括蜂巢，门户和其他
 */
export function judeEnv() {
    // 判断userAgent中是否拥有标识
    function matchUserAgent(reg) {
        return !!navigator.userAgent.match(reg)
    }
    // 是否从蜂巢进入
    function isFengChao() {
        let bool = false
        if (matchUserAgent(/CombWebView/)) {
            bool = true
        }
        return bool
    }
    // 是否从信息门户进入
    function isXXMH() {
        let bool = false

        function GetRequest() {
            var url = location.search // 获取url中"?"符后的字串
            var theRequest = {}
            if (url.indexOf('?') !== -1) {
                var str = url.substr(1)
                var strs = str.split('&')
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = decodeURI(
                        strs[i].split('=')[1]
                    )
                }
            }
            return theRequest
        }
        const query = GetRequest()
        if (query.combStr) {
            bool = true
            Cookies.set('combStr', query.combStr)
        }
        return bool
    }
    const environment = {
        isMobie: false,
        isFengChao: false,
        isXXMH: false
    }
    isFengChao()
        ? (environment.isFengChao = true)
        : (environment.isFengChao = false)
    isXXMH() ? (environment.isXXMH = true) : (environment.isXXMH = false)
    return environment
}

/**
 * 通用的Action请求函数，接收两个参数，返回一个相关的函数
 * @param {*} params dispatch函数传递的参数
 * @param {*} fn 要触发的异步函数一般是一个异步的ajax请求
 */
export async function requestAction(params, fn) {
    const response = await fn(params)
    if (response.data.status !== 1000) {
        // S.$vux.toast.text(response.data.msg, 'bottom')
        S.$createToast({
            type: 'error',
            time: 1500,
            txt: response.data.msg
        }).show()
        return Promise.reject
    } else {
        return (commitType, commit) => {
            if (typeof commitType === 'string') commit(commitType, response.data.result)
            return response
        }
    }
}
